// extracted by mini-css-extract-plugin
export default {"button":"mGZq6b","disabled":"oiLfOz","big":"_7fcAqG","medium":"rETiGx"};